export default "__VITE_ASSET__BgL5dI5I__"